import { styled } from 'baseui'
import { FlexBetween, FlexCenterY } from '@/shared/theme/styled-components'

export const StyledContainer = styled('div', ({ $theme, $mastered }) => ({
  width: '100%',
  border: `0.1rem solid ${$mastered ? $theme.colors.warning400 : 'transparent'}`,
  borderRadius: $theme.borders.radius300,
}))

export const StyledTopContainer = styled('div', () => ({
  width: '100%',
  padding: '1rem',
}))

export const StyledHeader = styled(FlexBetween, {
  marginBottom: '0.5rem',
})

export const StyledTitle = styled('h3', ({ $theme }) => ({
  marginTop: 0,
  marginBottom: 0,
  marginLeft: 0,
  marginRight: 0,
  fontWeight: '600',
  fontSize: '1.125rem',
  lineHeight: '160%',
  color: $theme.colors.textHeading,
}))

export const StyledIndicator = styled('span', ({ $theme }) => ({
  fontWeight: '600',
  fontSize: '1.125rem',
  lineHeight: '160%',
  color: $theme.colors.textHeading,
}))

export const StyledCurrentValue = styled('span', ({ $theme, $reachedMax }) => ({
  color: $reachedMax ? $theme.colors.positive600 : $theme.colors.mono500,
}))

export const StyledSubtitle = styled('p', ({ $theme }) => ({
  margin: '0 0 0.75rem 0',
  fontSize: '0.85rem',
  color: $theme.colors.textSecondaryAlt,
}))

export const StyledProgressBarContainer = styled('div', () => ({
  width: '100%',
}))

export const StyledProgressTrack = styled('div', ({ $theme, $mastered }) => ({
  position: 'relative',
  width: '100%',
  height: $theme.sizing.scale400,
  borderRadius: '0.5rem',
  overflow: 'hidden',
  background: $mastered ? $theme.colors.positive500 : 'linear-gradient(90deg, #FFA051 0%, #FFD152 55%, #25A337 100%)',
}))

export const StyledProgressMask = styled('div', ({ $percentDone }) => ({
  position: 'absolute',
  top: 0,
  right: 0,
  bottom: 0,
  width: `${100 - $percentDone}%`,
  backgroundColor: 'rgba(255, 255, 255, 0.7)',
  transition: 'width 0.3s ease',
}))

export const StyledItemsContainer = styled('div', ({ $theme }) => ({
  borderTop: `0.1rem solid ${$theme.colors.borderSoft}`,
}))

export const StyledItemRow = styled('div', ({ $theme, $done }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  padding: '0.5rem 1rem',
  backgroundColor: $done ? $theme.colors.positive50 : 'transparent',
}))

export const StyledItemLeft = styled(FlexCenterY, {
  gap: '0.5rem',
})

export const StyledItemLabel = styled('span', ({ $theme, $done }) => ({
  color: $done ? $theme.colors.positive600 : $theme.colors.textHeading,
}))

export const StyledDoneIcon = styled('span', ({ $theme }) => ({
  display: 'inline-flex',
  color: $theme.colors.positive500,
}))

export const StyledPendingIcon = styled('span', ({ $theme }) => ({
  display: 'inline-flex',
  color: $theme.colors.mono500,
}))
